import type { FaireProductEntity } from "../../entity_types/product";

export const p_jrgfnuscxw: FaireProductEntity = {
  token: "p_jrgfnuscxw",
  type: "product",
  name: "Chicago Fry Sauce – Creamy Everything & More Dipping Sauce",
  brandToken: "b_dhw3mqf63g",
  brandName: "Big Fork",
  imageUrl:
    "https://cdn.faire.com/fastly/2685ceea4bc67b7d9ca355180c8f332de64586c2e8d5a9a73decd0ff0b0cdd28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/986bdab5e8c58032d080d4379faa39d1704138a1a49065e486e762c6af0dd034.png",
    "https://cdn.faire.com/fastly/a3986a3583532d92e736202d3b9aa94c1e9c4aba8985aaa6f87b0a3c1893b33b.png",
    "https://cdn.faire.com/fastly/f09c66931f4d4c0209d1c5006f310bfd26e41538b8f001bd2edc13fcc11a5fa3.png",
    "https://cdn.faire.com/fastly/0cae13a464dc3fbed52ae3aba6f70634eb9ac8c3a99a575492ce964ac04325f3.jpeg",
    "https://cdn.faire.com/fastly/cc2d1859f3fa777f0384302fc3fdeb121bdab0edfad5c65623eb1c8c608abf6f.jpeg",
    "https://cdn.faire.com/fastly/d8e2934b82f812bb058b80ee391e7b5f6c72e772706deed0f6ce85e9d65d8a77.png",
    "https://cdn.faire.com/fastly/0a17577857d0843fc71ad64fc51f886638efa4cd4d96f2e49c44cbdad3dfdadc.png",
  ],
  priceDollars: 5.42,
  description:
    "Chicago Fry Sauce is the better-tasting version of Special Sauce. Inspired by the 7 classic toppings of a Chicago-style hot dog, we blend mustard, relish, pickles, tomatoes, onions, sport peppers, and celery salt into a smooth, craveable condiment. Then we take it further: Chicago Fry Sauce = Chicago Sauce + Mayo + Ketchup.\n\nThe result? A sauce that outshines yum yum sauce, special sauce, secret sauce, Big Mac sauce, and even remoulade — versatile, bold, and downright delicious. Perfect for dunking fries, onion rings, or tots, spreading onto burgers and fried chicken sandwiches, or swirling into potato salad and slaw. Made in small batches in Chicago with clean, high-quality ingredients, it’s the sauce that makes everything better. Beyond making great food, we're committed to giving back. We periodically donate to the Greater Chicago Food Depository, helping fight hunger across our city.\n\nFavorite Applications: Fries, tots, burgers, roasted veggies, pulled pork, and Reubens\n\nWays to Use Chicago Fry Sauce:\n\nDunk fries, tots, or onion rings straight in\nSpread onto burgers, fried chicken sandwiches, or wraps\nSwirl into potato salad or coleslaw for extra zip\n\n⚠️ Danger: Contains Ketchup (Chicagoans will understand)\n\n",
  tags: [],
  msrpDollars: 10.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:13.494Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
